import script from "./HrListTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HrListTable.vue?vue&type=script&setup=true&lang=js"

import "./HrListTable.vue?vue&type=style&index=0&id=3b48427c&lang=css"

const __exports__ = script;

export default __exports__